import { LoginCallback } from "@/features/login-callback";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/login-callback")({
  component: LoginCallback,
});
